import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import store from './store';
import reportWebVitals from './reportWebVitals';

// Configure QueryClient with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds - data is considered fresh for 30 seconds
      cacheTime: 5 * 60 * 1000, // 5 minutes - keep in cache for 5 minutes
      refetchOnMount: true, // Always refetch on mount to get latest data
      refetchOnWindowFocus: true, // Refetch when window gains focus to catch updates
      retry: 2, // Retry twice on failure
      refetchOnReconnect: true, // Refetch on reconnect
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </QueryClientProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
